import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInitialStateInstitutions, IInstitutePayload } from "../types";
import { IEntityWithIDTranslations } from "../../../../types";

const initialState: IInitialStateInstitutions = {
    legalType: [],
    institute: [],
    instituteID: 0,
};

const educationalInstitutionSlice = createSlice({
    name: "institutions",
    initialState,
    reducers: {
        setLegalType: (state, action: PayloadAction<{ data: IEntityWithIDTranslations[] }>) => {
            const { data } = action.payload;
            state.legalType = data;
        },
        setInstitute: (state, action: PayloadAction<IInstitutePayload[]>) => {
            state.institute = action.payload;
            if (Array.isArray(action.payload) && action.payload.length > 0 && action.payload[0]?.id) {
                state.instituteID = action.payload[0].id;
            }
        },
    },
});

export const { setLegalType, setInstitute } = educationalInstitutionSlice.actions;

export default educationalInstitutionSlice;
